const getQueryKeys = (accessToken: string) => ({
  all: () => ["notifications", accessToken],
});

export default getQueryKeys;
